/** Map API / promise rejections to a safe user-visible string. */
export function getUserFacingErrorMessage(error: unknown, fallback: string): string {
    if (typeof error === "string") {
        const t = error.trim();
        return t.length > 0 ? t : fallback;
    }
    if (error instanceof Error) {
        const t = error.message.trim();
        return t.length > 0 ? t : fallback;
    }
    if (error && typeof error === "object" && "message" in error) {
        const msg = (error as { message: unknown }).message;
        if (typeof msg === "string" && msg.trim().length > 0) return msg.trim();
    }
    return fallback;
}

/** Log full error in dev only (avoids noisy production consoles). */
export function logErrorForDev(context: string, error: unknown): void {
    if (import.meta.env?.DEV) console.error(`[${context}]`, error);
}
